<div class="popup">
  <div class="title" style="margin: 20px 0 0 20px">Change tenant</div>
  <div class="field-class">
    <button class="tenant-option" (click)="onClickTenantList()">
      <div class="tenant-icon"><img class="tenant-list-icon"/></div>
      <div class="tenant-txt">Select from existing tenants</div>
    </button>
    <button class="tenant-option" (click)="onClickNewTenant()">
      <div class="tenant-icon"><img class="new-tenant-icon"/></div>
      <div class="tenant-txt">Create new tenant</div>
    </button>
  </div>
  <div class="button-area flex">
    <button [mat-dialog-close] class="cancel-button outline-none h-10">Cancel</button>
  </div>
</div>
      